import { z } from 'zod'
import { LoginRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// A key absent from the raw input stays absent -- introducing it (even as null/undefined)
// would add a wire key callers never sent, breaking exact-body assertions downstream.
const normalize = fieldNormalizer({
  always: { trimmed: ['email'], textOrEmpty: ['password'] },
  bool: ['remember'],
  blankToNull: ['timezone']
})

export const AuthLogin = (_context: NoContext) =>
  z.preprocess(normalize, LoginRequestSchema.strict())
